import {vfjsGlobalMixin} from "vue-form-json-schema/src";
import EventBus from "../eventbus";

const ElioCustomVueFormJsonSchema = {
    name: 'custom-vue-form-json-schema',
    mixins: [vfjsGlobalMixin],
    render() {
        EventBus.$on("handleExternalErrors", (errors) => {
            this.handleExternalErrors(errors);
        });
        return this.$createElement(this.tag, this.vfjsFields);
    },
    methods: {
        __convertExternalErrorResponse(errorResponse) {
            return errorResponse.reduce((accum, currentVal) => {
                //currentVal.property is in format "[33]" for field id 33. So we need to crop first and last letter.
                let key = currentVal.property.substring(1, currentVal.property.length -1);
                accum[key] = currentVal.message;
                return accum;
            }, {});
        },
        handleExternalErrors(errorResponse) {
            console.log('external error handler triggered');
            let errors = this.__convertExternalErrorResponse(errorResponse)

            //loop over all form fields.
            for(let child in this.$children) {
                if(this.$children.hasOwnProperty(child)) {
                    let currentChildRefs = this.$children[child].$refs;

                    for(let ref in currentChildRefs) {
                        if(currentChildRefs.hasOwnProperty(ref)) {
                            //reset previous error messages.
                            currentChildRefs[ref].resetValidation();

                            let currentRefId = ref.substr(10);

                            //check if current ref is erroneous
                            if(errors.hasOwnProperty(currentRefId)) {
                                //apply new error messages
                                currentChildRefs[ref].innerError = true;
                                currentChildRefs[ref].innerErrorMessage = errors[currentRefId];
                            }
                        }
                    }
                }
            }
        }
    }
};

export default ElioCustomVueFormJsonSchema;